import { _js } from '@ifixit/localize';
import * as React from 'react';
import { ListBullet } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const BulletListButton = props => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBulletList().run()}
         isActive={editor.isActive('bulletList')}
         isDisabled={!editor.can().toggleBulletList()}
         icon={<ListBullet />}
         title={_js('Add a bulleted list')}
         shortcut={'shift+8'}
      />
   );
};
